import type { PropsWithChildren } from "react";
import { Link } from "react-router-dom";
import daeulLogo from "@/assets/Daeul_logo_eng_v2_cropped.png";

const PublicTermsLayout = ({ children }: PropsWithChildren) => (
  <main className="min-h-screen bg-[#F3F6FB] text-slate-900">
    <header className="border-b border-slate-200 bg-white/95 shadow-sm backdrop-blur">
      <div className="mx-auto flex min-h-20 w-full max-w-5xl items-center justify-between gap-4 px-4 sm:px-6 lg:px-8">
        <Link to="/terms" className="inline-flex items-center" aria-label="다을 약관 목록">
          <img src={daeulLogo} alt="Da:eul" className="h-9 w-auto object-contain sm:h-10" />
        </Link>
        <div className="flex items-center gap-2 rounded-full border border-teal-200 bg-teal-50 px-3 py-1.5 text-xs font-semibold text-teal-700">
          <span className="h-1.5 w-1.5 rounded-full bg-teal-500" />
          공개 약관
        </div>
      </div>
    </header>
    <div className="mx-auto w-full max-w-5xl px-4 py-7 sm:px-6 sm:py-10 lg:px-8">
      <div className="mb-6">
        <p className="text-xs font-semibold text-blue-600">고객지원 · 정책</p>
        <p className="mt-1 text-sm text-slate-500">서비스 이용에 필요한 약관과 개인정보 처리방침을 확인할 수 있습니다.</p>
      </div>
      {children}
      <footer className="mt-10 border-t border-slate-200 pt-5 text-xs text-slate-400">© Da:eul. 공개 약관 조회 전용 페이지입니다.</footer>
    </div>
  </main>
);

export default PublicTermsLayout;
